import { Box } from '@mui/material';
import React from 'react';
import { Area, ComposedChart, Line, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import theme from 'theme';

const OnboardingTileGraph: React.FC<{ onboardingStatus: number }> = ({ onboardingStatus }) => {
  const progressCurveData = [
    {
      name: 'Curve 1',
      progress: 100,
    },
    {
      name: 'Curve 2',
      progress: 70,
    },
    {
      name: 'Curve 3',
      progress: 80,
    },
    {
      name: 'Curve 4',
      progress: 70,
    },
    {
      name: 'Curve 5',
      progress: 60,
    },
    {
      name: 'Curve 6',
      progress: 70,
    },
    {
      name: 'Curve 7',
      progress: 70,
    },
  ]; // this data has been manually picked for achieving the desired look in the design

  const progressBar = (status: number) => {
    switch (status) {
      case 2:
        return '140 420'; // 560 total length, 25%
      case 3:
        return '476 84'; // 560 total length, 85%
      default:
        return '0 560';
    }
  };

  return (
    <Box height="25%">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={progressCurveData} margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
          <YAxis reversed dataKey="progress" domain={[0, 100]} axisLine={false} hide />
          <XAxis dataKey="name" axisLine={false} tickLine={false} interval={0} tick={{ fontSize: 14 }} hide />
          <Area
            dataKey="progress"
            fill="#66BA72"
            stroke="none"
            type="monotone"
            fillOpacity={1}
            isAnimationActive={false}
          />
          <Line
            dataKey="progress"
            stroke={theme.palette.primary.dark}
            type="monotone"
            strokeWidth={6}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            dataKey="progress"
            stroke={theme.palette.primary.main}
            type="monotone"
            strokeWidth={6}
            dot={false}
            strokeDasharray={progressBar(onboardingStatus)}
            animationEasing="ease-in-out"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default OnboardingTileGraph;
